/**
 *
 * Terms and Conditions for GPS
 *
 */

import React from 'react';
import './TermsForGPS.scss';

const TermsForGPS = (props) => {
  return (
    <div className="terms-for-gps-wrapper">
      <div className="terms-for-gps-container">
        <div className="page-title">TERMS OF USE</div>
        <p>
        “Wheelseye” is owned by <b>Wheelseye Technology India Private Limited.</b>
        The following terms and conditions govern  the  use  of  the website and mobile application
         (whether  through  a  computer, mobile phone or other electronic devices), and include all sections, 
         information, recommendations and other products and services available
          on or through the website and mobile application.
          <br/>
          <br/>
          By viewing or using the website www.wheelseye.com and mobile application Wheelseye, 
          you acknowledge that you have read and understood these customer terms (these “customer terms”).
            Please ensure that you read and understand all of these customer terms
             before you start using the website and mobile application,
              as you will be bound by these customer terms. By accessing or using the Web Site,
               you and the entity you are authorized to represent ("You" Or "Your")
                signify your agreement to be bound by the “Terms of Use”.
          <br/><br/>
                If you do not agree with any of these customer terms, you must immediately cease accessing
                 and using the website or mobile application and the services being provided there under.
                 Your acceptance of these customer terms will operate as a binding agreement between you and
                  Wheelseye Technology India Pvt. Ltd. in respect of your use of the website
                   and the mobile application and services.
                   <br/><br/>
                   These Customer Terms apply to customer access to, and use of, the
                    website and mobile applicationin case of any queries about these terms and conditions
                     or any comments or complaints on or about the website, you may kindly email
                      support@wheelseye.com.
        </p>
        <br/>
        <div className="highlight">PARTIES</div>
        <br/>
        <p>These Customer Terms are between you and/or the entity you are authorized to represent
           (here in after referred to as “customer”) and by Wheelseye Technology India Private Limited.
            By accepting the terms you signify your agreement to be bound by these “Terms of Use”.</p>
            <br/> 
        <div className=''>THE PARTIES AGREE AS FOLLOWS:</div>
        <ol className="terms-list" >
          <li>
          <div className="list-item-title">SCOPE OF TERMS OF USE</div>
            <p>            
            These Terms of Use govern the customer’s use of the web site, mobile application (whether through a
             computer, mobile phone or other electronic device), software and services (collectively,
             "Services") available via the web site and mobile application ,except to the extent such Services are 
             the subject of a separate agreement. Specific terms or agreements may apply to the use of certain Services
             and other items provided to the customer via the website or mobile application
             ("Service Agreement(s)"). Any such Service Agreements accompany or are listed in association with or through
             a hyperlink associated with the applicable Services.
            </p>
          </li>
          <li>
            <span className="list-item-title">USER ELIGIBILITY</span>
            <ul type="none">
              <li>
                <p>
                <span className="">2.1</span>      The Website and Mobile Application is not available to minors i.e. Customer represents that customers
are of legal age to form a binding contract and are not a person barred from viewing the website or the
mobile under the applicable statutory laws (in any relevant jurisdiction) all laws, including rules of
common law, principles of equity, statutes, regulations, proclamations, ordinances, by-laws, rules,
statutory rules of an industry body, statutory and mandatory codes or guidelines or the like, writs, orders,
injunctions, judgments applicable from time to time.
                </p>
              </li>
              <li>
                <p>
                <span className="">2.2</span> The customer must provide Wheelseye with accurate, complete, current, valid and true Registration
Data and the customer can only open one Account using the customer’s own registration data, and not
use the account of any other person.
                </p>
              </li>
              <li>
                <p>
                <span className="">2.3</span> Only use the Application solely in accordance with these Customer Terms and all Applicable Laws, and
do not use the website and mobile application, for any illegal or unlawful purposes.
                </p>
              </li>
              <li>
                <p>
                <span className="">2.4</span>    Only use the website and mobile application, for the customer’s sole, personal use, and do not transfer,
sell, sub-license or assign it to a third party
                </p>
              </li>
              <li>
                <p>
                <span className="">2.5</span> The customer agrees that amongst other limitations on the use of this website and mobile application
posting any defamatory or abusive language website and mobile application is also prohibited.
                </p>
              </li>
              <li>
                <p>
                <span className="">2.6</span> The Wheelseye reserves the right to refuse access to the website and mobile application as well as any
services provided therein to new users/customers or to terminate access granted to an existing user(s) at
any time without according to any reason for doing so.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <div className="list-item-title">PAYMENTS</div>
            <ul type="none">
              <li>
                <p>
                <span className="">3.1</span> The customer understands that use of the Services may result in charges for the services or goods that
you receive ("Charges"). Wheelseye will receive and/or enable the customer’s payment of the applicable
Charges for services or through your use of the Services. Charges will be inclusive of applicable taxes
where required by law. While availing any of the payment method/s offered including credit facility by
Wheelseye, Wheelseye will not be responsible or assume any liability, whatsoever in respect of any loss or
damage arising directly or indirectly to the customer due to:
                <ol type="a">
                  <li>
                    <p>Lack of authorisation for any transaction(s): or</p>
                  </li>
                  <li>
                    <p>Exceeding the preset limit mutually agreed upon by User and Users Bank: or</p>
                  </li>
                  <li>
                    <p>Any payment issue arising out of the transaction: or</p>
                  </li>
                  <li>
                    <p>The decline of the transaction for any other reason </p>
                  </li>
                  <li>
                    <p>All payments made against the Services provided by Wheelseye shall be in Indian Rupees
acceptable by the Union of India. Wheelseye does not accept any other form of currency</p>
                  </li>
                </ol>
                </p>
              </li>
            </ul>
          </li>
          <li>
          <div className="list-item-title">About Wheelseye Wallet</div>
          <ul type="none">
              <li>
                <p>
                <span className="">4.1</span> “Wheelseye Wallet” a closed wallet is issued to You. It allows You to load a rupee value onto Your
Wheelseye Wallet to access the Services available only on the Wheelseye application. The value associated
with Wheelseye Wallet is not insured or guaranteed by any person or entity.
                </p>
              </li>
              <li>
                <p>
                <span className="">4.2</span> Wheelseye Wallet can be loaded on the Wheelseye Platform using either credit card/debit card / UPI /
Internet Banking. One Wheelseye Wallet cannot be reloaded by using any other registered/ unregistered
Wheelseye Wallet.
                </p>
              </li>
              <li>
                <p>
                <span className="">4.3</span> Wheelseye reserves the right to limit the use of a Wheelseye Wallet if we reasonably believe that the use is
unauthorized, fraudulent, or otherwise unlawful. Further, misuse of the Wheelseye Wallet or its benefits
in any manner may result in the disablement of the Wheelseye Wallet and/or withdrawal of benefits at the
sole discretion of Wheelseye. Please maintain the Wheelseye Wallet safely and securely.
                </p>
              </li>
              <li>
                <p>
                <span className="">4.4</span> The balance in Wheelseye Wallet comes with an expiry time, the amount in Wheelseye Wallet is valid for
a period of 365 days. In the event, no transaction is carried out on Your Wheelseye Wallet consecutively
for a period of 365 days, the unutilized/unused balance in your Wheelseye Wallet shall be forfeited.
                </p>
              </li>
              <li>
                <p>
                <span className="">4.5</span> The credits available in the Wheelseye wallet can’t be cancelled or transferred to another account or any
third party. It can’t be withdrawn in the form of cash or transferred to any bank account.
                </p>
              </li>
          </ul>
          </li>
          <li>
          <div className="list-item-title">MODIFICATION</div>
          <ul type="none">
              <li>
                <p>
                <span className="">5.1</span> Wheelseye may amend, revise and update these terms of use from time to time. The customer’s continued
usage of the website or mobile application after any changes to these terms of use will mean that the
customer accepts those changes. Any aspect of the website may be changed, supplemented, deleted or
updated without notice at the sole discretion of Wheelseye. Wheelseye may also change or impose fees
for products and services provided through the website or mobile application at any time in its sole
discretion.
                </p>
              </li>
          </ul>
          </li>
          <li>
          <div className="list-item-title">WHEELSEYE PRIVACY POLICY</div>
          <ul type="none">
              <li>
                <p>
                <span className="">6.1</span> Wheelseye Privacy Policy governs the use of information collected from or provided by the customer at
the website and mobile application. With respect to any individual/organization whose personal
information is provided by the customer to Wheelseye, the customer represents to Wheelseye that the
customer has obtained all required permissions for the processing of such personal information as
contemplated by the services being used by the customer including the transfer of such data to other
countries whose laws may not provide the same level of protection for the personal data as the laws of
the country of origin of such individual.
                </p>
              </li>
              <li>
                <p>
                <span className="">6.2</span> Our data practices are subject to applicable laws in the places in which Wheelseye operate. This means
that we engage in the practices described in these terms of use in a particular country or region only if
permitted under the laws of those jurisdictions.
                </p>
              </li>
              <li>
                <p>
                <span className="">6.3</span> You agree to provide us access to your information as defined in these terms like name, mobile number,
vehicle number stored in your device (including geo-location; Your IP address; device ID or unique
identifier; device manufacturer and type; device and hardware settings; SIM card usage; applications
installed on your device; web browser; operator; keywords and data of incoming and outgoing calls and
messages; Your interaction with our Services such as how the Services are being accessed (via another
service, web site or a search engine); the pages You visit and features you use on the Services; the services
and websites You engage with from the Services; content viewed by You, content You have commented
on or sent to us and information about the ads You see and/or engage with; the search terms You use;
order information and other usage activity), including without limitation for the time period prior to the
date of registration of your Account with Wheelseye.
                </p>
              </li>
          </ul>
          </li>
          <li>
          <div className="list-item-title">LICENSE AND OWNERSHIP</div>
          <ul type="none">
              <li>
                <p>
                <span className="">7.1</span> The website and mobile application, the processes, and their selection and arrangement, including but not
limited to, all text, videos, graphics, user interfaces, Photos, visual interfaces, sounds and music (if any),
artwork and computer code (and any combinations thereof) (collectively, the “Content”) on the website
and mobile application is owned and controlled by the Wheelseye and/ or its licensors and the design,
structure, selection, coordination, expression, look and feel and arrangement of such content is protected
by copyright, patent and trademark laws, and various other intellectual property rights.
                </p>
              </li>
              <li>
                <p>
                <span className="">7.2</span> The trademarks, logos and service marks and all rights therein are and shall remain Wheelseye’s property
or the property of Wheelseye's licensors/vendors or other respective third parties, as the case may be.
Neither these Terms nor customer’s use of the Services convey or grant to the customer any rights: (i) in
or related to the Services except for the limited license granted in these terms; or (ii) to use or reference in
any manner Wheelseye 's company names, logos, product and service names, trademarks or services
marks or those of Wheelseye's licensors.
                </p>
              </li>
          </ul>
          </li>
          <li>
          <div className="list-item-title">DISCLAIMER OF WARRANTIES & LIMITATION OF LIABILITY</div>
          <ul type="none">
              <li>
                <p>
                <span className="">8.1</span> Customer expressly understands and agrees that, to the maximum extent permitted by applicable law. The
website, mobile application and all related content are provided by Wheelseye on an “as is” basis without
warranty of any kind, express, implied, statutory or otherwise, including the implied warranties of title,
non-infringement, merchantability or fitness for a particular purpose. Without limiting the foregoing,
Wheelseye makes no warranty that (i) the Website, mobile application or any related content or services
will meet customer requirements or customer’s use of the website, mobile application or related content
and services will be uninterrupted, timely, secure or error-free; (ii) the results that may be obtained from
the use of the website, mobile application or related services will be effective, accurate or reliable; (iii) the
quality of the website, mobile application or related services or content will meet customer expectations;
or (iv) any errors or defects in the website, mobile application or related services and content will be
correct. No advice or information, whether oral or written, obtained by the customer from the company
or through the use of the website, mobile application or related services shall create any warranty not
expressly stated in the Terms of Use.
                </p>
              </li>
              <li>
                <p>
                <span className="">8.2</span> Wheelseye will have no liability related to any user Content arising under intellectual property rights, libel,
privacy, publicity, obscenity, or other laws. Wheelseye also disclaims all liability with respect to the misuse,
loss, modification, or unavailability of any customer’s content.
                </p>
              </li>
              <li>
                <p>
                <span className="">8.3</span> Wheelseye will not be liable for any loss that the customer may incur as a consequence of unauthorized
use of its Account or Account information in connection with the website, mobile application or other
related services, either with or without customer knowledge.
                </p>
              </li>
              <li>
                <p>
                <span className="">8.4</span> Wheelseye has endeavoured to ensure that all the information on the Website and the mobile application
is correct, but Wheelseye neither warrants nor makes any representations regarding the quality, accuracy
or completeness of any data, or information available on the website or mobile application. 
                </p>
              </li>
              <li>
                <p>
                <span className="">8.5</span> Wheelseye shall not be responsible for the delay or inability to use the Website or mobile application or
related functionalities, the provision of or failure to provide functionalities, or for any information,
software, functionalities and related graphics obtained through the website, mobile application or
otherwise arising out of the use of the website or mobile application, whether based on contract, tort,
negligence, strict liability or otherwise. Further, the Wheelseye shall not be held responsible for the nonavailability of the website or mobile application during periodic maintenance operations or any unplanned
suspension of access to the website or mobile application that may occur due to technical reasons or for
any reason beyond the Wheelseye's control. 
                </p>
              </li>
              <li>
                <p>
                <span className="">8.6</span> The customer understands and agrees that any material or data or content downloaded or otherwise
obtained through the website or mobile application is done entirely at the customer’s own discretion and
risk, and that the customer will be solely responsible for any damage to the customer’s loss of data that
results from the download of such material or data.
                </p>
              </li>
          </ul>
          </li>
          <li>
          <div className="list-item-title">RESTRICTIONS ON THE USE OF THE WEBSITE AND MOBILE APPLICATION:</div>
          <ul type="none">
              <li>
                <p>
                <span className="">9.1</span> In addition to other restrictions set forth in these Terms of use and You undertake not to:
                </p>
                <ol type="a">
                  <li>
                    <p>defame, abuse, harass, threaten or otherwise violate the legal rights of others;</p>
                  </li>
                  <li>
                    <p>publish, post, upload, distribute or disseminate any inappropriate, profane, defamatory, infringing,
obscene, indecent or unlawful topic, name, material or information;</p>
                  </li>
                  <li>
                    <p>copy, republish, post, display, translate, transmit, reproduce or distribute any Content through any
medium without obtaining the necessary authorization from the Wheelseye;</p>
                  </li>
                  <li>
                    <p>conduct or forward surveys, contests, pyramid schemes or chain letters;</p>
                  </li>
                  <li>
                    <p>upload or distribute files that contain software or other material protected by applicable intellectual
property laws unless You own or control the rights thereto or have received all necessary consents;</p>
                  </li>
                  <li>
                    <p>upload or distribute files that contain viruses, corrupted files, or any other similar software or
programs that may damage the operation of the Website or another's computer or provide you an
undue advantage or benefit in purchasing goods / availing services; </p>
                  </li>
                  <li>
                    <p>engage in any activity that interferes with or disrupts access to the Website, mobile application or
their contents and services (or the servers and networks which are connected to the website or
mobile application);</p>
                  </li>
                  <li>
                    <p>attempt to gain unauthorized access to any portion or feature of the website, mobile application or
any other systems or networks connected to the website, or mobile application, to any Wheelseye
server, or to any of the website or mobile application services, by hacking, fraud calls, password
mining or any other illegitimate means;</p>
                  </li>
                  <li>
                    <p>probe, scan or test the vulnerability of the website, mobile application, or any network connected
to the website, mobile application, nor breach the security or authentication measures on the
website or mobile application or any network connected to the website or mobile application. You
may not reverse look-up, trace or seek to trace any information on any other User, of or visitor to,
the website, mobile application or to its source, or exploit the Content, or information made
available or offered by or through the website or mobile application in any way whether or not the
purpose is to reveal any information, including but not limited to personal identification
information, other than Your own information, as provided on the website or mobile application;</p>
                  </li>
                  <li>
                    <p>disrupt or interfere with the security of, or otherwise cause harm to, the website, mobile
application, systems resources, accounts, passwords, servers or networks connected to or
accessible through the website, mobile application or any affiliated or linked sites;</p>
                  </li>
                  <li>
                    <p>collect or store data about other Users in connection with the prohibited conduct and activities set
forth in this section.</p>
                  </li>
                  <li>
                    <p>use any device or software to interfere or attempt to interfere with the proper working of the
website, mobile application or any transaction being conducted on the website, mobile application
or with any other person’s use of the website or mobile application;</p>
                  </li>
                  <li>
                    <p>use the website, mobile application or any material or Content for any purpose that is unlawful or
prohibited by these Terms of Use, or to solicit the performance of any illegal activity or other
activity which infringes the rights of the Wheelseye or other third parties.</p>
                  </li>
                  <li>
                    <p>falsify or delete any author attributions, legal or other proper notices or proprietary designations or
labels of the origin or source of software or other material contained in a file that is uploaded;</p>
                  </li>
                  <li>
                    <p>violate any applicable laws or regulations for the time being in force within or outside India or
anyone’s right to privacy or personality;</p>
                  </li>
                  <li>
                    <p>violate the Terms of Use contained herein or elsewhere; and</p>
                  </li>
                  <li>
                    <p>reverse engineer, modify, copy, distribute, transmit, display, perform, reproduce, publish, license,
create derivative works from, transfer, or sell any information or software obtained from the
website or mobile application.</p>
                  </li>
                </ol>
              </li>
          </ul>
          </li>
          <li>
          <div className="list-item-title">RESTRICTIONS</div>
          <ul type="none">
              <li>
                <p>
                <span className="">10.1</span> Customer may not (i) remove any copyright, trademark or other proprietary notices from any portion of
the services; (ii) reproduce, modify, prepare derivative works based upon, distribute, license, lease, sell,
resell, transfer, publicly display, publicly perform, transmit, stream, broadcast or otherwise exploit the
website, mobile application or related services except as expressly permitted by Wheelseye; (iii) decompile,
reverse engineer or disassemble the website, mobile application or related services except as may be
permitted by applicable law; (iv) link to, mirror or frame any portion of the website, mobile application or
related services; (v) cause or launch any programs or scripts for the purpose of scraping, indexing,
surveying, or otherwise data mining any portion of the website or related services or unduly burdening or
hindering the operation and/or functionality of any aspect of the website or related services; or (vi)
attempt to gain unauthorized access to or impair any aspect of the website, mobile application or related
services or its related systems or networks.
                </p>
              </li>
              <li>
                <p>
                <span className="">10.2</span> Except as expressly indicated hereinabove, the Wheelseye hereby grants the customer, a non-exclusive,
freely revocable, non-transferable access to view any content available on the website and mobile
application, subject to the following conditions:
                </p>
                <ol type="a">
                  <li>
                    <p>Customer may access the Content solely for personal, informational, and internal purposes, in
accordance with the Terms of Use;</p>
                  </li>
                  <li>
                    <p>Customer may not modify or alter the Content available on the website or mobile application ;</p>
                  </li>
                  <li>
                    <p>Customer may not distribute or sell, rent, lease, license or otherwise make any Content on the
website or mobile application available to others; and</p>
                  </li>
                  <li>
                    <p>Customer may not remove any text, copyright or other proprietary notices contained in the
Content downloaded from the website or mobile application</p>
                  </li>
                </ol>
              </li>
          </ul>
          </li>
          <li>
          <div className="list-item-title">TERMINATION</div>
          <ul type="none">
              <li>
                <p>
                <span className="">11.1</span> Customer agrees that Wheelseye, in its sole discretion, may terminate or suspend customer’s use of the
website, mobile application, content and related services at any time and for any reason whatsoever in its
sole discretion. Upon such suspension or termination, customer must immediately (a) discontinue use of
the website, mobile application, content and relate services and (b) destroy any copies customer may have
made of any portion of the content of Wheelseye. Accessing the website, mobile application after such
termination, suspension or discontinuation shall constitute as an act of trespass. Further, customer agrees
that Wheelseye shall not be liable to or any third party for any termination or suspension of customer
access to the website.
                </p>
              </li>
          </ul>
          </li>
          <li>
          <div className="list-item-title">Limitation of Liability:</div>
          <p>In no event shall Wheelseye, its suppliers or any third parties mentioned at the website or mobile
application be liable for any incidental, indirect, exemplary, punitive and consequential damages, lost
profits, or damages resulting from lost data or business interruption resulting from the use of or inability
to use the website or mobile application.</p>
          </li>
          <li>
          <div className="list-item-title">INDEMNITY</div>
          <ul type="none">
              <li>
                <p>
                <span className="">13.1</span> Customer agrees to indemnify, defend and hold harmless Wheelseye and its affiliates including but not
limited to its (and its affiliates) officers, directors, consultants, agents, employees and vendors on the
website and mobile application (“Indemnitees”) from and against any and all losses, liabilities, claims,
damages, demands, costs and expenses (including legal fees and disbursements in connection therewith
and interest chargeable thereon) asserted against or incurred by the Indemnitees that arise out of, result
from, or may be payable by virtue of, any breach or non-performance of any representation, warranty,
covenant or agreement made or obligation to be performed by the customer pursuant to these Terms of
Use. Further, the customer agrees to hold the Indemnitees harmless against any claims made by any third
party due to or arising out of, or in connection with, customer use of the website, mobile application, or
website services or content, any misrepresentation with respect to the data or information provided by
customer, customer’s violation of the terms of use, or customer’s violation of any rights of another,
including violation of any intellectual property rights.
                </p>
              </li>
          </ul>
          </li>
          <li>
          <div className="list-item-title">IP INFRINGEMENT</div>
          <ul type="none">
              <li>
                <p>
                <span className="">14.1</span> If customer believes the website, mobile application or any of its services violates customer’s intellectual
property, customer must promptly notify the Wheelseye in writing at legal@wheelseye.com.These
notifications should only be submitted by the owner of the intellectual property or an agent authorized to
act on his/her behalf. However, any false claim by customer may result in the termination of customer’s
access to the website or mobile application. Customer is required to provide the following details in the
notice:
                </p>
                <ol type="a">
                  <li>
                    <p>the intellectual property that customer believes is being infringed;</p>
                  </li>
                  <li>
                    <p>the item that customer think is infringing and include sufficient information about where the
material is located on the website or mobile application;</p>
                  </li>
                  <li>
                    <p>a statement that customer believes in good faith that the item that has been identified as infringing
is not authorized by the intellectual property owner, its agent, or the law to be used in connection
with the website or mobile application;</p>
                  </li>
                  <li>
                    <p>customer contact details, such as customer address, telephone number, and/or email</p>
                  </li>
                  <li>
                    <p>a statement that the information customer provided in customer notice is accurate, and that
customer is the intellectual property owner, or an agent authorized to act on behalf of the
intellectual property owner whose intellectual property is being infringed; and customer physical or
electronic signature.</p>
                  </li>
                </ol>
              </li>
          </ul>
          </li>
          <li>
          <div className="list-item-title">DISPUTE RESOLUTION</div>
          <ul type="none">
              <li>
                <p>
                <span className="">15.1</span> It is agreed by the Customer that in case of any conflicts and inconsistencies arising out of and touching
upon the terms of this documents, the matter shall be referred to and governed by the Arbitration and
Conciliation Act, 1966 (as amended up to date of this document).
                </p>
              </li>
              <li>
                <p>
                <span className="">15.2</span> Each Party shall appoint one arbitrator and the two appointed arbitrators shall appoint third arbitrator
who shall preside the arbitration.
                </p>
              </li>
              <li>
                <p>
                <span className="">15.3</span> The seat on arbitration/ arbitrators shall be in New Delhi. 
                </p>
              </li>
              <li>
                <p>
                <span className="">15.4</span> The decision of the arbitration shall be final and binding on both the parties. 
                </p>
              </li>
          </ul>
          </li>
          <li>
          <div className="list-item-title">JURISDICTION</div>
          <p>These terms shall be governed by and constructed in accordance with the laws of India, customer hereby
expressly agrees that any proceeding arising out of or relating to customer’s use of the website, mobile or
related services shall be instituted in courts in Delhi, India only</p>
          </li>
          <li>
          <div className="list-item-title">SEVERABILITY</div>
          <p>If any provision of these Terms of Use is found to be invalid by any court having competent jurisdiction,
the invalidity of such provision shall not affect the validity of the remaining provisions of these Terms of
Use, which shall remain in full force and effect.</p>
          </li>
          <li>
          <div className="list-item-title">COMPLETE AGREEMENT</div>
          <p>Except as expressly provided in other written Agreement between the customer and Wheelseye these
Terms of Use constitute the Entire Agreement between the customer and Wheelseye with respect to the
use of the website and mobile application.</p>
          </li>
          <li>
          <div className="list-item-title">WAIVER</div>
          <p>Any failure by the Wheelseye to enforce or exercise any provision of the Terms of Use, or any related
right, shall not constitute a waiver by the Wheelseye of that provision or right.</p>
          </li>
          <li>
          <div className="list-item-title">DISCLAIMERS</div>
          <p>The products, services and offers referred to herein are subject to the terms and conditions governing
them as specified by Wheelseye from time to time and are offered at the sole discretion of Wheelseye.
Nothing contained herein shall constitute or be deemed to constitute an advice, invitation, or solicitation
to purchase any products/ services of Wheelseye.<br/><br/> Wheelseye makes no representation about the quality,
delivery, usefulness or otherwise of the goods / services offered by the third party.
Wheelseye may, at its sole discretion, utilize the services of external service provider/ s or agent/s. Misuse
of any intellectual property, or any other content displayed herein is strictly prohibited.</p>
          </li>

        </ol>
        <p>Your Wallet will be made inactive. Once Your Wallet is made inactive, it can be reactivated only after completing
the applicable due diligence process.</p>
      </div>
    </div>
  );
};

export default TermsForGPS;
